import React from 'react'

import { SelectField, SelectFieldProps } from '@global/field/SelectField'

const SelectFieldBase: React.FC<SelectFieldProps> = (props) => {
  return <SelectField {...props} />
}

export const ModalBodyInputSelect = Object.assign(SelectFieldBase)
